import React, {useContext } from "react";
import { Box, CircularProgress } from "@mui/material";
import SimResultsList from "../components/SimResultsList";
import { ResultsContext } from "../ResultsContext";
import useFetchImgs from "../useFetchImgs";


const FireListPage = () => {
  const {
    fireResults,
    filteredFireResults,
    setFilteredFireResults
  } = useContext(ResultsContext);

  return (
    <Box sx={{ p: 2, border: 0, justifyContent: "center", display: "flex" }}>
     
      <SimResultsList
        type_of_claim={"Fire"}
        data={filteredFireResults}
        setFilteredResults={setFilteredFireResults}
        originalData={fireResults}
      />
    </Box>
  );
};


export default FireListPage;
